import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import i18n from '../../../../i18next';

const ConfirmationModal = (props) => {

    return (
        <Modal isOpen={props.isOpen} toggle={props.toggle} size="md">
                <ModalHeader className="modalHeader" toggle={props.toggle}>{props.title}</ModalHeader>
                <ModalBody>
                    <h6 style={{ marginBottom: 15 }} >{props.message}</h6>
                    <Button
                        style={{ marginRight: 10, position: 'relative' }}
                        color="primary"
                        disabled={props.disabled}
                        onClick={props.onClick}
                    >
                        {i18n.t('common:buttons.confirm')}
                        {props.loader()}
                    </Button>
                    <Button onClick={props.toggle}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalBody>
            </Modal>
    )
}

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/restaurants/orders/orderDetailsCommon/ConfirmationModal.js